import script from "./Vesting.vue?vue&type=script&lang=ts&setup=true"
export * from "./Vesting.vue?vue&type=script&lang=ts&setup=true"

import "./Vesting.vue?vue&type=style&index=0&id=43cf78a6&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/curl-fe-build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43cf78a6"]])

export default __exports__